import { useEffect, useState } from 'react';
import { Moon, Sun } from '@phosphor-icons/react';
import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import Tippy from '@tippyjs/react';
import { TIPPY_TOOLTIP } from '@/lib/tippyTooltip';

type ThemeToggleProps = {
  className?: string;
};

/** Alterna entre tema claro e escuro. */
export function ThemeToggle({ className }: ThemeToggleProps) {
  const { resolvedTheme, setTheme } = useTheme();
  const [mounted, setMounted] = useState(false);

  useEffect(() => setMounted(true), []);

  const isDark = resolvedTheme === 'dark';
  const label = isDark ? 'Tema claro' : 'Tema escuro';

  return (
    <Tippy content={label} {...TIPPY_TOOLTIP}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className={cn(
          'shrink-0 text-muted-foreground hover:text-foreground hover:bg-accent/80',
          className,
        )}
        onClick={() => setTheme(isDark ? 'light' : 'dark')}
        disabled={!mounted}
        aria-label={label}
      >
        {!mounted ? (
          <span className="h-4 w-4 rounded-sm bg-muted-foreground/15" aria-hidden />
        ) : isDark ? (
          <Sun className="h-4 w-4 transition-transform duration-200" strokeWidth={2} />
        ) : (
          <Moon className="h-4 w-4 transition-transform duration-200" strokeWidth={2} />
        )}
      </Button>
    </Tippy>
  );
}
